import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { TurnoverListWidgetComponent } from '@main-application/turnovers/components/turnover-list/turnover-list-widget/turnover-list-widget.component';
import { PipesModule } from '@shared/pipes/pipes.module';
import { ChartModule } from '@ui-components/components/chart/chart.module';

@NgModule({
  declarations: [TurnoverListWidgetComponent],
  imports: [CommonModule, MatProgressSpinnerModule, ChartModule, PipesModule],
  exports: [TurnoverListWidgetComponent],
})
export class TurnoverListWidgetModule {}
